module.exports = __webpack_public_path__ + "141d4a85/img/cadBim.e369a02a.png";